export const makeObserveElementVisibility = (ObserverCtor)=>(element, onBecameVisible)=>{
        let disposed = false;
        const observer = new ObserverCtor((entries)=>{
            if (!disposed && entries.some((entry)=>entry.isIntersecting)) {
                onBecameVisible();
            }
        });
        observer.observe(element);
        return ()=>{
            if (!disposed) {
                disposed = true;
                observer.disconnect();
            }
        };
    };
